import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';

import ModalWithFinalForm from '../ModalWithFinalForm';
import FormFieldTextOrNumber from '../../formFields/FormFieldTextOrNumber';
import FormFieldWithDropdown from '../../formFields/FormFieldWithDropdown';
import FormFieldWithCheckbox from '../../formFields/FormFieldWithCheckbox';

const dropdownOptionPropTypes = PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}));

const propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    onSubmit: PropTypes.func,
    translations: PropTypes.object,
    rule: PropTypes.object,
    previousPaymentStatusOptions: dropdownOptionPropTypes,
    paymentStatusOptions: dropdownOptionPropTypes,
    currentOrderStatusOptions: dropdownOptionPropTypes,
    orderStatusOptions: dropdownOptionPropTypes
};

const PaymentToOrderStatusRuleEditionModal = ({
    isOpen,
    setIsOpen,
    onSubmit,
    translations,
    rule,
    previousPaymentStatusOptions,
    paymentStatusOptions,
    currentOrderStatusOptions,
    orderStatusOptions
}) => {
    if (!rule) {
        return null;
    }

    const initialValues = {
        ...rule,
        previousPaymentStatus: rule.previousPaymentStatus ?? null,
        currentOrderStatusId: rule.currentOrderStatusId ?? null
    };

    const handleSubmit = (formData) => {
        onSubmit({
            ...rule,
            ...formData,
            previousPaymentStatus: formData.previousPaymentStatus ?? null,
            currentOrderStatusId: formData.currentOrderStatusId ?? null
        });
    };

    return (
        <ModalWithFinalForm
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onConfirm={handleSubmit}
            initialValues={initialValues}
            header={translations.title}
            buttons={{
                confirm: {
                    color: 'success',
                    label: translations.buttons.confirm
                },
                cancel: {
                    color: 'danger',
                    label: translations.buttons.cancel
                }
            }}
            modalBody={
                <React.Fragment>
                    <Row className='my-2'>
                        <FormFieldTextOrNumber
                            name='name'
                            type='text'
                            label={translations.labels.name}
                        />
                    </Row>
                    <Row className='my-2'>
                        <FormFieldWithDropdown
                            name='previousPaymentStatus'
                            label={translations.labels.previousPaymentStatus}
                            options={previousPaymentStatusOptions}
                            currentSelectionLabel={previousPaymentStatusOptions.find(option => option.id === initialValues.previousPaymentStatus)?.label}
                        />
                    </Row>
                    <Row className='my-2'>
                        <FormFieldWithDropdown
                            name='paymentStatus'
                            label={translations.labels.paymentStatus}
                            options={paymentStatusOptions}
                            currentSelectionLabel={paymentStatusOptions.find(option => option.id === initialValues.paymentStatus)?.label}
                        />
                    </Row>
                    <Row className='my-2'>
                        <FormFieldWithDropdown
                            name='currentOrderStatusId'
                            label={translations.labels.currentOrderStatus}
                            options={currentOrderStatusOptions}
                            currentSelectionLabel={currentOrderStatusOptions.find(option => option.id === initialValues.currentOrderStatusId)?.label}
                        />
                    </Row>
                    <Row className='my-2'>
                        <FormFieldWithDropdown
                            name='orderStatusId'
                            label={translations.labels.orderStatus}
                            options={orderStatusOptions}
                            currentSelectionLabel={orderStatusOptions.find(option => option.id === initialValues.orderStatusId)?.label}
                        />
                    </Row>
                    <Row className='my-2'>
                        <FormFieldTextOrNumber
                            name='priority'
                            type='number'
                            min={0}
                            step='1'
                            label={translations.labels.priority}
                        />
                    </Row>
                    <Row className='my-2'>
                        <FormFieldWithCheckbox
                            name='enabled'
                            label={translations.labels.enabled}
                        />
                    </Row>
                </React.Fragment>
            }
        />
    );
};

PaymentToOrderStatusRuleEditionModal.propTypes = propTypes;

export default PaymentToOrderStatusRuleEditionModal;
